import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListLoader } from '../list-loader/list-loader';
import { LoadingState } from '../list-loader/loading-state';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { CapFormRowDirective } from '../../form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { FormsModule } from '@angular/forms';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { CapSpinnerSmallComponent } from '../cap-spinner-small/cap-spinner-small.component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { DecimalHochkommaPipe } from '../../pipes/simple/decimalHochkomma.pipe';

@Component({
  selector: 'cap-list-loader',
  templateUrl: './list-loader-wrapper.component.html',
  styleUrls: ['./list-loader-wrapper.component.scss'],
  imports: [
    CapFormRowDirective,
    CapFormControlComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    CapSpinnerSmallComponent,
    NgbPagination,
    TranslatePipe,
    DecimalHochkommaPipe
  ]
})
export class ListLoaderWrapperComponent<T> implements OnInit {
  @Input()
  showZeilenSelect: boolean;
  @Input()
  showTotal = true;
  @Input()
  keineTranslateKey = 'Keine';
  @Input()
  listLoader: ListLoader<T>;
  @Input()
  defaultText = 'gemaessGrundbuch';

  _hasRight = true;

  public loadingState = LoadingState;

  @Output() currentPageEventItem = new EventEmitter<true>();

  constructor() {
    keysToTranslate<string>(['Keine', 'Eintrag', 'Eintraege']);
  }

  ngOnInit(): void {
    if (this.listLoader) {
      this.listLoader.state$.subscribe((state) => {
        if (state === LoadingState.ACCESS_DENIED) {
          this.hasRight = false;
        }
      });
    }
  }

  @Input()
  set hasRight(value: boolean) {
    if (value === null || value === undefined) {
      return;
    }
    this._hasRight = value;
  }

  currentPageChangeEventEmit() {
    this.currentPageEventItem.emit(true);
  }
}
